import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoqateEmailValidateDirective } from '@df/module-loqate/email/loqate-email.validator';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { TradeClassDirective } from '../multisite/trade/trade-class.directive';
import { ActionComponent } from '../ui/api/action.component';
import { CheckboxComponent } from '../ui/form/checkbox';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { ResultComponent } from '../ui/resut/result.component';
@Component({
    selector: 'newsletter-form',
    templateUrl: './newsletter-form.html',
    styleUrls: ['./newsletter-form.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        CheckboxComponent,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoqateEmailValidateDirective,
        OffClickModule,
        ResultComponent,
        TradeClassDirective,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterFormComponent extends NewsletterFormComponentDef {
    @Input()
    isFooter: boolean = false;
    protected defaultSuccessMessage = "Thank you. You're signed up and your first LeMieux email will be on its way to you soon.";
    protected _showSubmitButton = false;
    set showSubmitButton(value) {
        this._showSubmitButton = value;
        this._ref.detectChanges();
    }
    get showSubmitButton() {
        return this._showSubmitButton;
    }
}
